module.exports = __webpack_public_path__ + "img/collection-weddingRingsFancy.88b5c4b.jpg";